/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AcceptTileUpdateRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'
import {AcceptTileUpdateResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/tile_messages.pb'


export const acceptTileUpdate = (request: AcceptTileUpdateRequest, options?: CashRequestOptions) => post<AcceptTileUpdateRequest, AcceptTileUpdateResponse>("/2.0/cash/accept-tile-update", request, {...options, rejectOnError: true })